import Popover from "components/shared/popover";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { enumLabel, formatNumber } from "helpers/system";
import React from "react";
import CarRenderer from "./car";

const CityCell = (props) => {
    if (!props.value) {
        return null;
    }
    return (
        <>
            {props.value?.cars.map((item, index) => (
                <CarRenderer key={index} item={item} {...props} />
            ))}
            {props.value.bids?.length > 0 && (
                <Popover text={`Заказов: ${props.value.bids.length}`} cname="cursor-pointer badge badge-primary">
                    <div className="px-3 pt-3 planning-table__required-bids-popover">
                        {props.value.bids.map((item, i) => (
                            <div key={i} className="pb-3">
                                <div
                                    className="card card-body py-2 px-3 planning-table__required-bid-item"
                                    onClick={() =>
                                        props.history.push(paths.distributionBidShow(item.distributionBidId))
                                    }
                                >
                                    <h6 className="mb-1">
                                        {item.firstPoint.city} → {item.lastPoint.city}
                                    </h6>
                                    <div>
                                        Время загрузки: <b>{dateTimeToView(item.firstPoint.planEnterDate)}</b>
                                    </div>
                                    <div>
                                        Стоимость:{" "}
                                        <b>
                                            {formatNumber(item.price, {
                                                style: "currency",
                                                currency: props.organization?.currency,
                                            })}
                                        </b>
                                    </div>
                                    <div>
                                        Тип прицепа: <b>{enumLabel(props.enums.trailerType, item.trailerTypeId)}</b>
                                    </div>
                                    <div>
                                        Контрагент: <b>{item.counterpartyName}</b>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Popover>
            )}
        </>
    );
};

export default CityCell;
